/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';
import { useFieldHelper } from 'framework/ui/field';

interface ProjectInternalReportCpiFieldProps {
  source: string;
  label: string;
}

const ProjectInternalReportCpiField = ({ source, label }: ProjectInternalReportCpiFieldProps) => {
  const { getValue: getData } = useFieldHelper({ source });
  const data = +getData();
  const color = data <= 1 ? 'success.main' : 'error.main';

  return (
    <Box component="p" sx={{ color }}>
      {' '}
      {data}{' '}
    </Box>
  );
};

export default ProjectInternalReportCpiField;
